import { PrankDefinition, Intensity } from './types';

const MIN_SCALE = 1.0;
const MAX_SCALE = 1.008;
const SCALE_STEP = 0.0005;
const TICK_MS = 200;
const INTENSE_MULTIPLIER = 4;

const breathingPrank: PrankDefinition = {
  namedCode: 'breathe',
  hexCode: '0e5d',
  create: (intensity) => {
    const speed = intensity === Intensity.INTENSE ? INTENSE_MULTIPLIER : 1;
    let scale = 1;
    let growing = true;

    const interval = setInterval(() => {
      scale += growing ? SCALE_STEP : -SCALE_STEP;
      if (scale >= MAX_SCALE) growing = false;
      if (scale <= MIN_SCALE) growing = true;
      document.documentElement.style.transform = `scale(${scale})`;
      document.documentElement.style.transformOrigin = 'center top';
    }, TICK_MS / speed);

    return () => {
      clearInterval(interval);
      document.documentElement.style.transform = '';
      document.documentElement.style.transformOrigin = '';
    };
  },
};

export default breathingPrank;
